export default __webpack_public_path__ + "static/media/product-09 (2).a789b9ea.jpg";